export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-orange-500 to-orange-600 text-white py-12">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          <div>
            <h3 className="text-xl font-bold mb-4">Sunil Electronics</h3>
            <p className="text-white/90 text-sm leading-relaxed">
              20+ saal ka anubhav ke saath electronics repair services. Local, trusted aur imandaar shop.
            </p>
          </div>
          
          <div>
            <h3 className="text-xl font-bold mb-4">Shop Timing</h3>
            <p className="text-white/90 text-sm">
              <i className="ri-time-line mr-2"></i>
              Daily: 10:00 AM – 10:00 PM
            </p>
            <p className="text-white/90 text-sm mt-2">
              <i className="ri-map-pin-line mr-2"></i>
              Chamber ki Dharamshala, Sikandrabad
            </p>
          </div>
          
          <div>
            <h3 className="text-xl font-bold mb-4">Contact</h3>
            <a 
              href="tel:9927256718"
              className="flex items-center gap-2 text-white/90 hover:text-white transition-colors text-sm mb-2 cursor-pointer"
            >
              <i className="ri-phone-line"></i>
              <span>9927256718</span>
            </a>
            <a 
              href="https://wa.me/919927256718"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-white/90 hover:text-white transition-colors text-sm cursor-pointer"
            >
              <i className="ri-whatsapp-line"></i>
              <span>WhatsApp Us</span>
            </a>
          </div>
        </div>
        
        <div className="border-t border-white/20 pt-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-white/80 text-sm">
              © 2025 Sunil Electronics. All rights reserved.
            </p>
            <p className="text-white/80 text-sm">
              Customers visit from Sikandrabad & nearby areas
            </p>
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-white/80 hover:text-white text-sm transition-colors cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
